// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Pn-z","summaryPar":"Qn-z","ratingCategories":"Rn-z","reviewerInfo":"Sn-z","reviewTypes":"Tn-z","expanded":"Un-z"};